import { RatingService } from '@app/shared/services/rating.service';
import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { SigninService } from '@app/authentication/services/signin.service';
import { ApiTypes, MessageConfig } from '@app/shared/constants/constant';
import { Storage } from '@ionic/storage';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AppUpdateService } from './app-update.service';
import { ServerConnectService } from './server-connect.service';
import { UtilService } from './util.service';
import { Userprivacy } from '@app/profile-setup/profile.model';
import { ActivatedRoute, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { Login } from '@app/authentication/authentication.model';
@Injectable({
  providedIn: 'root',
})
export class AuthSessionService {
  public logIn = new Login();
  public token: string;
  public activeRoute = new Subject<any>();
  public type = ApiTypes;
  public userSessionSubject = new BehaviorSubject<any>(null);
  public $userSession = this.userSessionSubject.asObservable();
  public userLoggedin = new BehaviorSubject<boolean>(null);
  public readOnly = new BehaviorSubject<boolean>(false);
  public roleID: any;
  public userId: any;
  public newUserRegister = false;
  public activeUrl: any;
  public userprivacy = new Userprivacy();
  private authStateSubscription: firebase.Unsubscribe | null = null;
  constructor(
    private storage: Storage,
    private serverConnectService: ServerConnectService,
    private appUpdateService: AppUpdateService,
    private router: Router,
    private signInService: SigninService,
    private utilService: UtilService,
    private activatedRoute: ActivatedRoute,
    private ratingService: RatingService,
  ) { }
  private blurActiveElement(): void {
    if (typeof document === 'undefined') {
      return;
    }
    const activeElement = document.activeElement as HTMLElement | null;
    activeElement?.blur?.();
  }
  public loadSession() {
    const onceSubscribe = this.appUpdateService.urlSetCompleted.subscribe(
      (res) => {
        if (res) {
          onceSubscribe.unsubscribe();
          if (!this.signInService.emailVerify) {
            this.startAuthSession();
          }
        }
      }
    );
    const onceSubscribe1 =
      this.appUpdateService.urlSetCompletedLoginError.subscribe((res) => {
        if (this.signInService.emailVerify) {
          this.startAuthSession();
        }
        this.signInService.emailVerify = false;
      });
  }

  public startAuthSession() {
    if (this.authStateSubscription) {
      return; // Already subscribed
    }
    this.authStateSubscription = firebase.auth().onAuthStateChanged((user) => {

      if (user != null && user.emailVerified) {
        this.userId = user.uid;
        this.storage.get('userdetails').then((value) => {
          if (value == null) {
            setTimeout(() => {
              this.signInService.sendlogin().then((data: any) => {
                if(data) {
                this.userSessionSubject.next(data.APILogin);
                this.roleID = data.APILogin.RoleID;
                this.userLoggedin.next(true);
                this.storage.clear();
                this.blurActiveElement();
                this.router.navigate([], { replaceUrl: true });
                if (data.APILogin.PrivacyForEmail !== undefined) {
                  this.userprivacy.emailflag = data.APILogin.PrivacyForEmail === '1' ||
                                              data.APILogin.PrivacyForEmail === 'true' ||
                                              data.APILogin.PrivacyForEmail === true;
                }
                this.storage.set('userdetails', data.APILogin);
                this.redirectAsPerRoalId();
               } else {
                firebase.auth().signOut();
                this.router.navigateByUrl('signin');
               }

              });
            }, 3000);
          } else {
            if (value.PrivacyForEmail !== undefined) {
              this.userprivacy.emailflag = value.PrivacyForEmail === '1' ||
                                         value.PrivacyForEmail === 'true' ||
                                         value.PrivacyForEmail === true;
            }
            this.userSessionSubject.next(value);
            this.userLoggedin.next(true);
            // Navigate immediately using cached role (skip if on public page)
            if (!this.router.url.startsWith('/fuel-delivery-note')) {
              if (value.RoleID == 7) {
                this.blurActiveElement();
                this.router.navigateByUrl('charter', { replaceUrl: true });
              } else {
                this.blurActiveElement();
                this.router.navigateByUrl('trips', { replaceUrl: true });
              }
            }
            // Load Google Maps in background
            if (typeof window !== 'undefined' && (window as any).loadGoogleMaps) {
              (window as any).loadGoogleMaps();
            }
          }
        });
      } else {
        if (!this.newUserRegister) {
          if (user && !user.emailVerified) {
            this.signInService.sendEmailVerification(user.email);
            this.utilService.showToastCtrl(MessageConfig.emailverify);
          } else {
            if (!this.router.url.startsWith('/fuel-delivery-note')) {
              firebase.auth().signOut();
              this.blurActiveElement();
              this.router.navigateByUrl('signin');
            }
            this.userLoggedin.next(false);
          }
        } else {
          this.utilService.dismissLoader();
          this.userLoggedin.next(false);
        }
      }
    });
  }
  public redirectAsPerRoalId() {
    this.$userSession.pipe(
      filter(res => res != null),
      take(1)
    ).subscribe((res) => {
      try {
        if (typeof window !== 'undefined' && (window as any).loadGoogleMaps) {
          (window as any).loadGoogleMaps();
        }
        this.signInService
          .checkFlag(res.firebase_uid)
          .then(async (userProfileStatus) => {
            this.utilService.dismissLoader();
            if (userProfileStatus == '0') {
              const navigationExtras: NavigationExtras = {
                state: {
                  fromPage: 'registration',
                },
              };
              this.router.navigate(['profile-setup'], navigationExtras);
            } else {
              // await this.highlightSideMenu(this.activeUrl);
              const currentUrl = this.router.url;
              switch (res.RoleID) {
                // client , vendor
                case 2:
                case 3:
                  if (!currentUrl.startsWith('/fuel-delivery-note')) {
                    this.blurActiveElement();
                    await this.router.navigateByUrl('trips');
                    await this.highlightSideMenu('/trips');
                  }
                  break;
                case 7:
                  this.blurActiveElement();
                  await this.router.navigateByUrl('charter');
                  break;
                default:
                  this.utilService.showAlertConfirm();
                  break;
              }
            }
          }).catch(() => {
            this.utilService.dismissLoader();
          });
      } catch (error) {
        this.utilService.dismissLoader();
        // this.logOut();
      }
    });
  }
  public async permission(moduleName: string, access: string) {
    return await new Promise(async (resolve, reject) => {
      this.$userSession.subscribe((res: any) => {
        if (res && res.permissions) {
          const permissions = Object.values(res.permissions);
          permissions.filter((re: any) => {
            if (re.Access) {
              if (re.Access.includes(access) && re.Module == moduleName) {
                return resolve(true);
              }
            }
          });
          resolve(false);
        } else if (res && res.RoleID != null && res.RoleID == '7') {
          return resolve(true);
        } else {
          setTimeout(() => {
            this.permission(moduleName, access);
          }, 200);
        }
      });
    });
  }
  public logOut() {
    this.storage.clear().then(() => {
      this.storage.remove('userdetails');
      firebase.auth().signOut();
      // this.userSessionSubject.next(null);
      this.userLoggedin.next(false);
      // Only navigate if not already on signin
      if (!this.router.url.startsWith('/signin')) {
        this.blurActiveElement();
        this.router.navigate(['signin'], {
          replaceUrl: true,
        });
      }
      this.utilService.dismissLoader();
    });
  }
  public async highlightSideMenu(url: string) {
    if (url) {
      const urlRoute = url.split('/');
      this.activeRoute.next(urlRoute[1]);
    }
  }
  public setRoleID() {
    this.$userSession.subscribe((res) => {
      if (res) {
        this.roleID = res.RoleID;
      }
    });
  }
}
